<template>
  <div id="resultat">
    <div
      class="row"
    >
      <div class="col-9 text-left">
        <div class="row">
          <div class="col-3">
            <img
              :src="logoClinique"
              style="width: 80px;"
            >
          </div>
          <div class="col-9 text-center">
            <h4 style="text-transform: uppercase; padding-top: 5px; font-size: 1.3rem; color: green;">
              {{ cliniqueName }}
            </h4>
            <small>KEGUE VON EPP KELEGOUGAN PRES ECHANGEUR</small><br>
            <small>RCCM: TG-LOM 2015 B 1735 - NIF: 1000582678 - 16BP375 - 90808147</small>
          </div>
        </div>
      </div>
        
      <div class="col-3 text-right">
        <img
          :src="logoCaseac"
          style="width: 80px;"
        >
      </div>
    </div>
    <hr style="color: rgba(0,0,0,0.9);  height: 5px;"/>
    <div class="row">
      <div
        class="col-12"
        style="margin-top: 0px; margin-bottom: 0px; text-align: center;"
      >
        <slot name="title" />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <fieldset v-if="proprietaire !== null" class="border p-1">
          <legend class="" >Propriétaire</legend>
          <div class="row">
            <div class="col-12">
              <i class="las la-user la-2x text-mutted"></i>
              <span class="fullname">{{ proprietaire.fullname }}</span>
            </div>
            <div class="col-12">
              <i class="las la-phone la-2x text-mutted"></i>
              <span class="text-mutted">{{ proprietaire.telephone }}</span>
            </div>
            <div class="col-12" v-if="proprietaire.address !== null">
              <i class="las la-map-marker la-2x text-mutted"></i>
              <span class="text-mutted">{{ proprietaire.address }}</span>
            </div>
          </div>
        </fieldset>
        
      </div>
      <div class="col-4 offset-4" v-if="accompagnant !== null">
        <fieldset  class="border p-1" >
          <legend class="">Accompagnant</legend>
          <div class="row">
            <div class="col-12">
              <i class="las la-user la-2x text-mutted" ></i>
              <span class="fullname">{{ accompagnant.fullname }}</span>
            </div>
            <div class="col-12">
              <i class="las la-phone la-2x text-mutted"></i>
              <span class="text-mutted">{{ accompagnant.telephone }}</span>
            </div>
            <div class="col-12" v-if="accompagnant.address !== null">
              <i class="las la-map-marker la-2x text-mutted"></i>
              <span class="text-mutted">{{ accompagnant.address }}</span>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row" v-if="hasAnimal">
      <div class="col-12">
        <fieldset class="border p-1">
          <legend>Animal</legend>
          <div class="row animal">
            <div class="col-4">
              <div class="row">
                <div class="col-12">
                  <label> Nom: </label>
                  {{ animal.name }}
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label> Code ISO: </label>
                  {{ animal.codeIso }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-12">
                  <label>Espèce:</label>
                  {{ espece | libelle }}
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>Race:</label>
                  {{ race |libelle }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-12">
                  <label>Age: </label>
                  {{ animal.dateNaissance | age }}
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>Sexe: </label>
                  {{ animal.sexe|sexe }}
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    
    
    <div class="row">
      <div class="col-12">
        <slot name="content" />
      </div>
    </div>

    <div
      class="row"
      style="margin-top: 20px; margin-bottom: 100px;"
    >
      <div class="col-6">
        <label>Date:</label>
        {{ dateObject|systemDateTime }}
      </div>
      <div class="col-6">
        Signature
      </div>
    </div>
  </div>
</template>

<script>
const  logoCaseac = require('../../../../assets/img/logo256.png')
const logoClinique = require('../../../../assets/img/clinique_logo.png')
import { CLINIQUE_FICHE_NAME } from '../../../../constants/app';
import { mapGetters } from 'vuex';
import moment from 'moment'
export default {
    props: {
        animalUid: {type: String, required: true},
        date: {type: String, default: null}
    },
    data(){
        return {
          logoCaseac,
          logoClinique
        }
    },
    computed:{
        ...mapGetters({
            animaux: 'identification/animaux',
            especes: 'identification/especes',
            races: 'identification/races',
            proprietaires: 'auth/proprietaires',
            accompagnants: 'auth/accompagnateurs',
        }),
        animal(){
            let a = this.animaux.find(item => item.uid === this.animalUid)
            if(a) return a
            return null
        },
        hasAnimal(){
            return this.animal !== null && this.animal !== undefined
        },
        espece(){
            return this.especes.some(item => item.uid === this.animal.espece)? this.especes.find(item =>item.uid === this.animal.espece) : null
        },
        race(){
            return this.races.some(item => item.uid === this.animal.race)? this.races.find(item =>item.uid === this.animal.race) : null
        },
        cliniqueName(){
            return CLINIQUE_FICHE_NAME
        },
        dateObject(){
            return moment(this.date)
        },
        proprietaire(){
            return this.proprietaires.some(item => item.uid === this.animal.proprio)? this.proprietaires.find(item =>item.uid === this.animal.proprio) : null
        },
        accompagnant(){
            return this.accompagnants.some(item => item.uid === this.animal.accompagnant)? this.accompagnants.find(item =>item.uid === this.animal.accompagnant) : null
        },
    }
}
</script>

<style lang="scss" scoped>
.animal{
    // padding: 20px;
    // border: solid 1px rgba($color: #000000, $alpha: 0.15);
    // border-radius: 5px;
    margin: 10px 0px 10px 0px;
    label{
        width: 25%;
    }
}
.text-mutted{
    color: rgba($color: #000000, $alpha: 0.5);
    margin-right: 20px;
}
fieldset{
    margin: 10px 0px 20px 0px;
    border-color: rgba($color: #000000, $alpha: 0.15) !important;
    border-radius: 5px;
    legend{
        width: auto;
        font-size: 1rem;
        color: rgba($color: (#000000), $alpha: 0.5);
        padding: 0px 10px;
    }
    .fullname{
        font-size: 1.2rem;
        font-weight: bold;
        color: rgba($color: (#000000), $alpha: 0.5)
    }
}
</style>